module.exports = __webpack_public_path__ + "img/product_4.b11d431.svg";